import ApiService from "../../utils/fetch";
const userRolesUrl = `${process.env.REACT_APP_BASE_URL}user-access/`;

export const fetchUserRequestData = async () => {
    const url = `${userRolesUrl}fetchRequestStatus`;
    const response = await ApiService.get(url);
    return response.data;
}

export const fetchApproverRequestStatuses = async () => {
  const url = `${userRolesUrl}fetchRequestForApproval`;
  const response = await ApiService.get(url);
  return response.data;
};

export const updateApproverAction = async (payload) => {
  const url = `${userRolesUrl}handleApprovalRequest`;
  const response = await ApiService.post(url, payload);
  return response.data;
};